import { useEffect, useState } from "react";

import Timeline from "./components/windows/Timeline";
import Home from "./components/windows/Home";
import Statistics from "./components/windows/Statistics";
import Taskbar from "./components/taskbar/Taskbar";
import Social from "./components/windows/Social";
import About from "./components/windows/About";
import Icon from "./components/icon/Icon";
import CodeSources from "./components/windows/CodeSources";
import Simulator from "./components/simulator/Simulator";
import Contact from "./components/windows/Contact";
import Projects from "./components/windows/Projects";

function App() {
  var zIndex = 1000;
  const [data, setData] = useState({});
  const [taskbar, setTaskbar] = useState({});

  useEffect(() => {
    fetch(
      "https://raw.githubusercontent.com/Pierre-LHOSTE/Pierre-LHOSTE.github.io/assets/cv.json"
    )
      .then(function (res) {
        return res.json();
      })
      .then((obj) => setData(obj));
  }, []);

  
  function checkWidth() {
    let info = document.body.getBoundingClientRect();
    if (info.width < 750) {
      let active = Array.from(document.querySelectorAll("article")).filter(
        (el) => el.style.zIndex >= zIndex
      )[0];
      if (!active) active = document.getElementById("home");
      document.querySelectorAll("article").forEach((article) => {
        updateTaskbar(article.id, "reduced");
      });
      updateTaskbar(active.id, "mobile");

    } else {
      let actives = Object.keys(taskbar).filter(
        (p) => taskbar[p].status == "mobile"
      );
      if (actives.length > 0) {
        actives.forEach((article) => {
          updateTaskbar(article, "opened");
        });
      }
    }
  }

  document.body.onresize = checkWidth;




















  function increaseZIndex(element) {
    let article = Array.from(document.querySelectorAll("article")).map(
      (el) => el.style.zIndex
    );
    zIndex = Math.max(...article) + 10;
    element.style.zIndex = zIndex;
  }

  function updateTaskbar(id, status = "opened", which) {
    let article = document.getElementById(id.toLowerCase());
    if (which == "taskbar") {
      let zIndexs = Array.from(document.querySelectorAll("article")).map(
        (el) => el.style.zIndex
      );
      let zIndex = Math.max(...zIndexs);
      if (article.style.opacity == 1 && article.style.zIndex  >= zIndex) {
        status = "reduced";
      } else {
        status = "opened";
      }
    }
    if (status == "opened") increaseZIndex(article);
    let info = document.body.getBoundingClientRect();
    if (info.width < 750 && status == "opened") {
      document.querySelectorAll("article").forEach((article) => {
        updateTaskbar(article.id, "reduced");
      });
      status = "mobile";
    }
    let obj = {
      status: status,
      id: id,
      name: article.children[0].children[0].outerText,
    };
    setTaskbar((current) => {
      return { ...current, [id.toLowerCase()]: obj };
    });
  }

  useEffect(() => {
    for (const id in taskbar) {
      let article = taskbar[id];
      const w = document.getElementById(id);
      
      let style = {};

      switch (article.status) {
        case "opened":
          const data_saved = JSON.parse(
            document.getElementById(article.id).getAttribute("data-saved")
          );
          style = {
            top: data_saved.top,
            left: data_saved.left,
            width: data_saved.width,
            height: data_saved.height,
            minWidth: "750px",
            minHeight: "450px",
            opacity: 1,
            transform: "none",
            pointerEvents: "auto",
          };
          break;
  
        case "reduced":
          const icon =
            document
              .getElementById("icon-" + article.id.toLowerCase())
              ?.getBoundingClientRect() || {};
          style = {
            top: icon.y + icon.height / 2 + "px",
            left: icon.x + icon.width / 2 + "px",
            minWidth: "0px",
            width: "0px",
            minHeight: "0px",
            height: "0px",
            opacity: "0",
            pointerEvents: "none",
          };
          break;
  
        case "closed":
          style = {
            transform: "scale(0.8)",
            opacity: "0",
            pointerEvents: "none",
          };
          break;
  
        case "mobile":
          style = {
            opacity: 1,
            top: 0,
            left: 0,
            width: "100%",
            height: "calc(100% - 70px - 4vh)",
            minWidth: "0",
            minHeight: "0",
            pointerEvents: "auto",
            transform: "none",
          };
          break;
      }

    style.transition = "all .3s ease-out";

      if (article.selected) {
        w.classList.add("selected");
      } else {
        w.classList.remove("selected");
      }

    for (const key in style) {
      w.style[key] = style[key];
    }

    setTimeout(reset, 300);

    function reset() {
      w.style.transition = "";
    }

    }
  },[taskbar])



























  useEffect(() => {
    // console.log(taskbar);
  }, [taskbar]);

  window.updateTaskbar = updateTaskbar;
  window.taskbar = taskbar;

  window.increaseZIndex = increaseZIndex;
  // window.updateWindow = updateWindow;

  if (!data.profile) return;

  return (
    <>
      <About />
      <Contact />
      <CodeSources />
      <Projects data={data.projets} />
      <Simulator />
      <Social data={data.interêts} />
      <Timeline data={data.formations} />
      <Statistics data={data.compétences} />
      <Home data={data.profile} />
      <div>
        {Object.values(window.taskbar).map((app, i) => (
          <Icon key={"icon-" + i} data={app} />
        ))}
      </div>

      <Taskbar />
    </>
  );
}

export default App;
